import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = (process.env.REACT_APP_API_URL||'/api').replace(/\/$/,'');

const css = `
* { box-sizing:border-box; margin:0; padding:0; }
body { font-family:Arial,sans-serif; background:#f0f4f8; min-height:100vh; }
.wrap { max-width:480px; margin:0 auto; padding:16px; }
.hdr  { background:#1a3a5c; border-radius:12px 12px 0 0; padding:18px 20px; display:flex; align-items:center; gap:12px; }
.logo { font-size:26px; }
.ttl  { font-size:13px; font-weight:700; color:#fff; }
.sub  { font-size:10px; color:rgba(255,255,255,.65); margin-top:2px; }
.body { background:#fff; border:1px solid #dde3ec; border-top:none; border-radius:0 0 12px 12px; padding:28px 22px; text-align:center; }
.icon-ok  { font-size:52px; color:#1a7a4a; margin-bottom:10px; }
.icon-bad { font-size:52px; color:#b03030; margin-bottom:10px; }
.status-ok  { font-size:16px; font-weight:700; color:#1a7a4a; margin-bottom:6px; }
.status-bad { font-size:16px; font-weight:700; color:#b03030; margin-bottom:6px; }
.msg  { font-size:12px; color:#555; margin-bottom:18px; line-height:1.5; }
.detail-box { background:#f7f9fc; border:1px solid #dde3ec; border-radius:9px; padding:14px 16px; text-align:left; margin-top:6px; }
.detail-row { display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #eef1f5; font-size:12px; }
.detail-row:last-child { border-bottom:none; }
.detail-lbl { color:#777; }
.detail-val { color:#1a3a5c; font-weight:600; text-align:right; }
.lopdp { font-size:9px; color:#999; margin-top:18px; line-height:1.5; }
.loading { padding:32px; text-align:center; color:#888; font-size:13px; }
`;

const fmtD = s => { if(!s) return '—'; const d = new Date(s); return d.toLocaleDateString('es-EC') + ' · ' + d.toLocaleTimeString('es-EC',{hour:'2-digit',minute:'2-digit'}); };

export default function VerificarFirma() {
  const { nro, hash } = useParams();
  const [estado, setEstado] = useState('cargando'); // cargando | ok | bad | error
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    verificar();
  }, [nro, hash]);

  const verificar = async () => {
    try {
      const r = await fetch(`${API}/laboratorio/verificar/${nro}/${hash}`);
      const d = await r.json();
      if (!r.ok) { setEstado('error'); return; }
      setDatos(d);
      setEstado(d.valido ? 'ok' : 'bad');
    } catch(_) { setEstado('error'); }
  };

  return (
    <>
      <style>{css}</style>
      <div className="wrap">
        <div className="hdr">
          <span className="logo">🔬</span>
          <div>
            <div className="ttl">Verificación de Documento Digital</div>
            <div className="sub">MediSys · Validación de autenticidad</div>
          </div>
        </div>

        <div className="body">
          {estado==='cargando'&&<div className="loading">Verificando documento...</div>}

          {estado==='error'&&(
            <>
              <div className="icon-bad">⚠️</div>
              <div className="status-bad">Error al verificar</div>
              <div className="msg">No se pudo conectar con el servidor de verificación. Intenta nuevamente.</div>
            </>
          )}

          {estado==='ok'&&datos&&(
            <>
              <div className="icon-ok">✅</div>
              <div className="status-ok">Documento auténtico</div>
              <div className="msg">{datos.mensaje}</div>
              <div className="detail-box">
                <div className="detail-row"><span className="detail-lbl">N° de informe</span><span className="detail-val">{datos.nro_informe}</span></div>
                <div className="detail-row"><span className="detail-lbl">Firmado por</span><span className="detail-val">{datos.laboratorista}</span></div>
                {datos.registro_msp&&<div className="detail-row"><span className="detail-lbl">Reg. MSP</span><span className="detail-val">{datos.registro_msp}</span></div>}
                <div className="detail-row"><span className="detail-lbl">Fecha validación</span><span className="detail-val">{fmtD(datos.fecha_validacion)}</span></div>
                {datos.paciente_iniciales&&<div className="detail-row"><span className="detail-lbl">Paciente</span><span className="detail-val">{datos.paciente_iniciales}</span></div>}
              </div>
            </>
          )}

          {estado==='bad'&&datos&&(
            <>
              <div className="icon-bad">❌</div>
              <div className="status-bad">Documento no válido</div>
              <div className="msg">{datos.mensaje}</div>
            </>
          )}

          <div className="lopdp">
            🔒 Esta verificación confirma la integridad y autenticidad del documento firmado digitalmente.<br/>
            Consultorio Médico Dr. Caicedo · Ambato, Ecuador
          </div>
        </div>
      </div>
    </>
  );
}
